<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:14:53
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-16 15:04:22
 * @FilePath: \newsmartmapout\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:14:53
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-04-22 16:32:21
 * @FilePath: \newsmartmapout\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <div class="aiBoxPop" v-show="isShowAiPop">
      <div class="aiBoxPopTitel">
        <div class="left">智慧小云 (DeepSeek R1)</div>
        <div class="right">
          <img
            src="./assets/close.png"
            @click="closeAiPop"
            class="aiCloseIcon"
            style="width:30px;height:30px"
            alt
          />
        </div>
      </div>
      <div class="aiBoxPopMainBox" v-loading="ailoading">
        <div class="littttine">欢迎使用智慧小云，可以询问我任何问题，我都将耐心回复</div>
        <div class="AilistItem" v-for="item in msgListdata">
          <div style="width:100%" :class="{ 'myright': item.dir }">
            <div class="itemTimeBox">15:00</div>
          </div>
          <div style="width:100%" :class="{ 'myright': item.dir }">
            <div class="textbox" :class="{ 'myright3': item.dir }">
              <span class="mytextBox" :class="{ 'myright2': item.dir }">{{item.msgData}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="AilistItem" v-for="item in 20">
          <div style="width:100%" class="myright">
            <div class="itemTimeBox">15:00</div>
          </div>
          <div style="width:100%" class="myright">
            <div class="textbox2">
              <span class="mytextBox">1212</span>
            </div>
          </div>
        </div>-->
      </div>
      <div class="aiBottomBox">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4}"
          placeholder="请输入内容"
          v-model="textarea2"
          class="myinptAibox"
        ></el-input>
        <div class="mybotomeBix" @click="sendAimsg">
          发送
          <!-- <el-button style type="primary" size="mini"  >发送</el-button> -->
        </div>
      </div>
    </div>
    <div class="myAiBox">
      <img src="./assets/AI.png" @click="openMyAiBox" style="width:100%;height:100%" alt />
    </div>
    <div class="headerBox" v-show="$route.path!='/'">
      <!-- <video
        muted
        autoplay="autoplay"
        preload="auto"
        playsinline
        loop
        src="./assets/newheader.webm"
        type="video/webm"
        class="mywivewBox"
      /> -->
      <!-- <div class="headerLeft" @click="isShowweatherPop=true">
        <img :src="weatherIconSrc" class="weatherImg" alt />
        {{weatherdata.cond_txt}} {{weatherdata.tmp_min}}~{{weatherdata.tmp_max}}℃
      </div>-->
      <div
        class="headerLeft"
        @click="isShowweatherPop=true"
      >温度:{{weatherdata.temp}}℃ &emsp; 降水:{{weatherdata.pre}}mm</div>
      <div class="headercenter">
        水电站来水预测气象服务平台
        <!-- <img src="./assets/6_dpr.png" style="width:100%" alt /> -->
      </div>
      <div class="headerright">
        <!-- <div class="atuoBox">
          <div>预警警报:</div>
          <div class="atuoBtn">
            <el-switch v-model="isOpenAtuoMusic"></el-switch>
          </div>
        </div>
        <div class="atuoBox">
          <div>自动轮播:</div>
          <div class="atuoBtn">
            <el-switch v-model="isOpenAtuo" @change="atuoChangePage"></el-switch>
          </div>
        </div>-->
        <div class="userInfoBox">
          <div class="userInfoBoxItem" @click="backToLogin">{{userName}}</div>
        </div>

        <div class="timeBox">
          <div class="dateText" style>{{dateStr}}</div>
          <div class="timeText" style>{{timeStr}}</div>
        </div>
      </div>
    </div>
    <div class="weatherInfoBox" v-show="isShowweatherPop">
      <div class="weatherTitleBox">天气信息详情</div>
      <div class="closeBoxImg" @click="isShowweatherPop=false">
        <img src="./assets/Frame_1714.png" style="width:100%;height:100%" alt />
      </div>
      <div>
        <!-- <div
          class="Showweathetitle"
        >雅安：今日天气{{weatherdata.cond_txt}}，{{weatherdata.tmp_min}}~{{weatherdata.tmp_max}}℃，平均气温{{weatherdata.tmp}}℃。{{weatherdata.wind_dir}}{{weatherdata.wind_sc}}级，气压{{weatherdata.pres}}hpa，湿度{{weatherdata.hum}}%。</div>
        </div>-->
        <div class="Showweathetitle">{{weatherInfoData[0].txt7}}</div>
      </div>
    </div>
    <!-- <div class="headerBotton">
      <div>龙门山芦山段位移0.03m</div>
      <div>龙门山芦山地灾隐患点黄色预警</div>
    </div>-->
    <!-- <el-dialog title="天气信息详情" :append-to-body="false" :visible.sync="isShowweatherPop" width="50%">
      <div
        class="Showweathetitle"
      >雅安：今日天气{{weatherdata.cond_txt}}，{{weatherdata.tmp_min}}~{{weatherdata.tmp_max}}℃，平均气温{{weatherdata.tmp}}℃。{{weatherdata.wind_dir}}{{weatherdata.wind_sc}}级，气压{{weatherdata.pres}}hpa，湿度{{weatherdata.hum}}%。</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowweatherPop = false">取 消</el-button>
        <el-button type="primary" @click="isShowweatherPop = false">确 定</el-button>
      </span>
    </el-dialog>-->
    <router-view class="myview" />
    <div v-show="$route.path!='/'">
      <div class="tabbarBox" v-show="isShowBottomTab">
        <!-- <div class="movebottom" @click="isShowBottomTab=false"></div> -->
        <div class="tabbarBoxList">
          <div
            style
            class="tabbarImgBox"
            @click="getpage('watch')"
            :class="[activeName=='watch'?'':'notChooseImg']"
          >
            <img
              src="./assets/Group 1321314905.png"
              class="routerImg"
              :class="[activeName=='watch'?'moeIcon':'']"
              alt
              srcset
            />
            <img src="./assets/iconback.png" class="routerImg2" alt />
            <!-- <img src="./assets/Group_1321314708.png" v-else class="iconimg" alt srcset /> -->
          </div>
          <div
            style
            class="tabbarImgBox"
            :class="[activeName=='for'?'':'notChooseImg']"
            @click="getpage('for')"
          >
            <img
              src="./assets/Group 13213149062.png"
              class="routerImg"
              :class="[activeName=='for'?'moeIcon':'']"
              alt
              srcset
            />
            <img src="./assets/iconback.png" class="routerImg2" alt />
            <!-- <img src="./assets/Group_1321314708.png" v-else class="iconimg" alt srcset /> -->
          </div>
          <div
            class="tabbarImgBox"
            @click="getpage('weaterFore')"
            :class="[activeName=='weaterFore'?'':'notChooseImg']"
          >
            <img
              src="./assets/Group 13213149101.png"
              :class="[activeName=='weaterFore'?'moeIcon':'']"
              class="routerImg"
              alt
              srcset
            />
            <img src="./assets/iconback.png" class="routerImg2" alt />
          </div>
          <!-- <div
            class="tabbarImgBox"
            @click="getpage('waring1')"
            :class="[activeName=='waring'?'':'notChooseImg']"
          >
            <img
              src="./assets/Group 1321314908.png"
              :class="[activeName=='waring'?'moeIcon':'']"
              class="routerImg"
              alt
              srcset
            />
            <img src="./assets/iconback.png" class="routerImg2" alt />
          </div> -->
          <!-- <div
            class="tabbarImgBox"
            @click="getpage('sbut')"
            :class="[activeName=='sbut'?'':'notChooseImg']"
          >
            <img
              src="./assets/Group 1321314909.png"
              :class="[activeName=='sbut'?'moeIcon':'']"
              class="routerImg"
              alt
              srcset
            />
            <img src="./assets/iconback.png" class="routerImg2" alt />
          </div>
          <div
            class="tabbarImgBox"
            @click="getpage('move')"
            :class="[activeName=='move'?'':'notChooseImg']"
          >
            <img
              src="./assets/Group 1321314910.png"
              :class="[activeName=='move'?'moeIcon':'']"
              class="routerImg"
              alt
              srcset
            />
            <img src="./assets/iconback.png" class="routerImg2" alt />
          </div> -->
        </div>
      </div>
      <div class="showTabBtn" v-show="!isShowBottomTab" @click="isShowBottomTab=true">
        <i class="el-icon-arrow-up" style="color:#60E6FF"></i>
      </div>
    </div>
    <div class="mybottomGlassBox">
      <div class="mybottomGlassBoxItemLeft">
        <div class="switchBox">
          <div>预警警报:</div>
          <div class="atuoBtn">
            <el-switch v-model="isOpenAtuoMusic" style="zoom:0.7"></el-switch>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="switchBox">
          <div>自动轮播:</div>
          <div class="atuoBtn">
            <el-switch v-model="isOpenAtuo" @change="atuoChangePage" style="zoom:0.7"></el-switch>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="switchBox">
          <div>自动站:</div>
          <div class="atuoBtn">
            <el-switch v-model="isOpenStation" @change="stationChange" style="zoom:0.7"></el-switch>
          </div>
        </div>
      </div>
      <div class="footerDataText">成都科达乐科技有限公司&四川省气象局&四川省地震局 联合研发</div>
      <div class="mybottomGlassBoxItemright">
          <div class="switchBox">
          <div>地震带:</div>
          <div class="atuoBtn">
            <el-switch v-model="isShowDz" style="zoom:0.7" @change="changeType('地震带')"></el-switch>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="switchBox">
          <div>水系:</div>
          <div class="atuoBtn">
            <el-switch v-model="isShowWater" style="zoom:0.7" @change="changeType('水系')"></el-switch>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="switchBox">
          <div>路网:</div>
          <div class="atuoBtn">
            <el-switch v-model="isShowrod" style="zoom:0.7" @change="changeType('路网')"></el-switch>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="switchBox">
          <div>居民区:</div>
          <div class="atuoBtn">
            <el-switch v-model="isShowpeo" style="zoom:0.7" @change="changeType('居民区')"></el-switch>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="switchBox">
          <div>水位:</div>
          <div class="atuoBtn">
            <el-switch v-model="isShowwater" style="zoom:0.7" @change="changeType('水位')"></el-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jsCookie from "js-cookie";
import moment from "moment";
import md5 from "js-md5";
export default {
  data() {
    return {
      ailoading: false,
      msgListdata: [],
      textarea2: "",
      isShowAiPop: false,
      isShowWater: false,
      isShowrod: false,
      isShowpeo: false,
      isShowwater: false,
      isShowDz: false,
      isOpenStation: false,
      userName: "对外账号",
      isShowBottomTab: true,
      isOpenAtuoMusic: false,
      weatherIconCode: 100,
      weatherIconSrc: require("./assets/weather/weather100.gif"),
      isOpenAtuo: false,
      changePageTimeer: null,
      weatherInfoData: [],
      isShowweatherPop: false,
      timeStr: "",
      dateStr: "",
      activeName: "watch",
      timeIndex: 0,
      weatherdata: {
        dis: 0.0001907141839999417,
        CityName: "雅安",
        cid: "CN101271701",
        cloud: 10,
        cond_code: 150,
        cond_txt: "晴",
        fl: -1,
        hum: 98,
        loc: 1703628240000,
        pcpn: 0,
        pres: 952,
        tmp: 4,
        vis: 2,
        wind_deg: 46,
        wind_dir: "东北风",
        wind_sc: "1",
        wind_spd: 5,
        tmp_max: 13,
        tmp_min: 3,

        timeHander: null
      },
      showTypeList: []
    };
  },

  created() {
    // console.log(this.$route.path);
    this.getweatherData();
    // this.timeStr = moment(new Date()).format("HH:mm:ss");
    // this.dateStr = moment(new Date()).format("YYYY-MM-DD");
    let t = this;
    setInterval(() => {
      // console.log(1121);
      t.timeStr = moment(new Date()).format("HH:mm:ss");
      t.dateStr = moment(new Date()).format("YYYY-MM-DD");
      // console.log(t.timeStr);
    }, 1000);
    this.getWeatherInfoData();
    this.userName = JSON.parse(jsCookie.get("areainfo")).nickName;
  },
  watch: {
    $route(to, from) {
      this.userName = JSON.parse(jsCookie.get("areainfo")).nickName;
    }
  },
  //   beforeDestroy(){
  // clearInterval(this.timeHander)
  //   },
  methods: {
    sendAimsg() {
      this.ailoading = true;
      this.msgListdata.push({
        msgData: this.textarea2,
        dir: true
      });
      let mytext = this.textarea2;
      this.textarea2 = "";
      // return;
      this.$axios({
        method: "post",

        url: `https://www.moodsci.com/data/deepseek/getDsMessages?content=${mytext}`
      }).then(res => {
        console.log(res.data.choices[0].message.content);
        if (res.data.choices[0] == undefined) {
          this.msgListdata.push({
            msgData: "出错了",
            dir: false
          });
        } else {
          this.msgListdata.push({
            msgData: res.data.choices[0].message.content,
            dir: false
          });
        }
        this.ailoading = false;
        console.log(this.msgListdata);
      });
    },
    closeAiPop() {
      this.isShowAiPop = false;
      this.msgListdata = [];
    },
    openMyAiBox() {
      this.isShowAiPop = true;
    },
    changeType(type) {
      console.log(this.showTypeList);
      if (this.showTypeList.indexOf(type) != -1) {
        console.log("have");
        let arr = JSON.parse(JSON.stringify(this.showTypeList));
        let newarr = arr.filter(function(item) {
          return item !== type;
        });
        console.log(newarr);
        this.showTypeList = newarr;
      } else {
        this.showTypeList.push(type);
      }
      this.$store.commit("setopenStr", this.showTypeList);
    },
    stationChange(e) {
      // console.log(e);
      this.$store.commit("setOpenstatdata", e);
      console.log(this.$store.state.isOpenStation);
    },
    atuoChangePage(e) {
      let myPageList = ["/watch", "/forecast", "/response"];
      let activeName = ["watch", "for", "call"];
      if (e) {
        this.changePageTimeer = setInterval(() => {
          console.log(2122);
          console.log(this.timeIndex);
          console.log(myPageList[this.timeIndex]);
          if (this.timeIndex < 2) {
            this.$router.push(myPageList[this.timeIndex]).catch(err => {
              console.log("输出报错", err);
            });
            this.activeName = activeName[this.timeIndex];
            this.timeIndex++;
          } else if (this.timeIndex == 2) {
            this.$router.push(myPageList[this.timeIndex]).catch(err => {
              console.log("输出报错", err);
            });
            this.activeName = activeName[this.timeIndex];
            this.timeIndex = 0;
          }
        }, 10000);
        this.$message({
          message: "已开启自动轮播",
          type: "success",
          offset: 100
        });
      } else {
        clearInterval(this.changePageTimeer);
        this.$message({
          message: "已关闭自动轮播",
          type: "success",
          offset: 100
        });
      }
    },
    getWeatherInfoData() {
      //  var hash = md5("value");
      ////console.log(hash);
      let timeStr = new Date().getTime();
      ////console.log();
      let sinCode = md5(
        timeStr.toString().substring(0, 8) +
          "53A51DAC-8986-4A4B-B3BC-89585C897110"
      );
      ////console.log(sinCode.substring(0, 16));
      this.$axios({
        method: "get",
        url: `https://int.scqx.net/?id=3030&sign=${sinCode.substring(0, 16)}`
      }).then(res => {
        // console.log(res);
        this.weatherInfoData = res.data.cdata.filter(e => e.sname == "雅安");
        // console.log(this.weatherInfoData);
      });
    },
    backToLogin() {
      this.$router.push("/");
    },
    getweatherData() {
      let formData = new FormData();

      formData.append("para", `{'datetime':'null','staname':'雅安'}`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/data/getKedaleHoursByStation`,
        data: formData
      }).then(res => {
        console.log("getWeatherData");
        // console.log(res.data.datas[0]);
        //  this.weatherTimeList =[]
        let myarr = [];
        Object.keys(res.data.datas).forEach(item => {
          myarr.push({
            fxTime: moment(item, "YYYY-MM-DD HH:mm:ss").format("HH:mm"),
            temp: res.data.datas[item].TEM,
            humidity: res.data.datas[item].WIN_S_Avg_2mi,
            pre: res.data.datas[item].PRE_1h
          });
          // console.log(item);
        });
        // this.weatherTimeList = myarr.reverse();
        console.log(myarr);
        this.weatherdata = myarr[0];
      });

      // this.$axios({
      //   method: "post",
      //   url: `
      //   http://120.79.183.250:3099/data/getActualElementsByPosition?Longitude=103.009&Latitude=29.999`,
      //   // url: `
      //   // /api/SWDataservice/interface/v1/api?interfaceId=getActualElementsByPosition&Longitude=103.009&Latitude=29.999`,
      //   headers: {
      //     "Content-Type": "application/x-www-form-urlencoded"
      //   }
      // }).then(res => {
      //   //console.log(111);
      //   console.log(res.data[0]);
      //   this.weatherdata = res.data[0];
      //   let code = res.data[0].cond_code;
      //   this.weatherIconCode = code;
      //   if (code == 100 || code == 150) {
      //     this.weatherIconCode = 100;
      //   } else if (
      //     code == 101 ||
      //     code == 102 ||
      //     code == 103 ||
      //     code == 151 ||
      //     code == 152 ||
      //     code == 153
      //   ) {
      //     this.weatherIconCode = 101;
      //   } else if (
      //     code == 300 ||
      //     code == 301 ||
      //     code == 303 ||
      //     code == 350 ||
      //     code == 351
      //   ) {
      //     this.weatherIconCode = 300;
      //   } else if (code == 305 || code == 308 || code == 309 || code == 399) {
      //     this.weatherIconCode = 305;
      //   } else if (code == 314) {
      //     this.weatherIconCode = 306;
      //   } else if (code == 315) {
      //     this.weatherIconCode = 307;
      //   } else if (code == 316) {
      //     this.weatherIconCode = 310;
      //   } else if (code == 317) {
      //     this.weatherIconCode = 311;
      //   } else if (code == 313 || code == 318) {
      //     this.weatherIconCode = 312;
      //   } else if (code == 406 || code == 407 || code == 457) {
      //     this.weatherIconCode = 407;
      //   } else if (code == 405 || code == 499) {
      //     this.weatherIconCode = 400;
      //   } else if (code == 408) {
      //     this.weatherIconCode = 401;
      //   } else if (code == 409) {
      //     this.weatherIconCode = 402;
      //   } else if (code == 404 || code == 410 || code == 456) {
      //     this.weatherIconCode = 403;
      //   } else if (code == 500 || code == 509 || code == 514 || code == 514) {
      //     this.weatherIconCode = 501;
      //   } else if (code == 510 || code == 511 || code == 512 || code == 513) {
      //     this.weatherIconCode = 502;
      //   }
      //   this.weatherIconSrc = require(`./assets/weather/weather${this.weatherIconCode}.gif`);
      //   // this.waringList = res.data.dataList;
      // });
    },
    getpage(data) {
      this.showTypeList=[]
       this.$store.commit("setopenStr", []);
      this.$store.commit("setOpenstatdata", false);
      this.isOpenStation=false
      this.isShowDz=false
      this.isShowWater=false
      this.isShowrod=false
      this.isShowpeo=false
      this.isShowwater=false
       
      this.activeName = data;
      if (data == "for") {
        this.$router.push("/forecast");
      } else if (data == "watch") {
        this.$router.push("/watch");
      } else if (data == "call") {
        this.$router.push("/response");
      } else if (data == "waring") {
        this.$router.push("/waringpage");
      } else if (data == "weaterFore") {
        this.$router.push("/weaterFore");
      }else {
        this.$message({
          message: "待开发",

          offset: 100
        });
      }
    }
  }
};
</script>
<style lang="scss">
@function px2vw($px) {
  @return $px * 100vw / 1920;
}
@font-face {
  font-family: "DingTalk JinBuTi";
  src: url("./assets/font.ttf");
}
.headercenter {
  position: absolute;
  z-index: 999;
  top: px2vw(7);
  left: px2vw(677);
  width: px2vw(564);
  height: px2vw(79);
  // background-color: aqua;
  font-size: 35px;
  color: #ABEEFE;
  text-align: center;
  font-weight: 800;
    font-family: DingTalk JinBuTi;
    line-height: px2vw(60);
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  /* background-color: aquamarine; */
}
.timeText {
  color: rgba(174, 228, 245, 1);
  font-family: DingTalk JinBuTi;
  font-size: px2vw(22);
}
.dateText {
  color: rgba(174, 228, 245, 1);
  font-family: DingTalk JinBuTi;
  font-size: px2vw(12);
}
.headerBox {
  height: px2vw(110);
  width: 100vw;
  // background-color: #0ab4e1;
  /* background-color: antiquewhite; */
  background-image: url("./assets/top.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: px2vw(30) 0px;
  position: absolute;
  z-index: 999;
  display: flex;
  justify-content: space-between;
}
.mywivewBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  object-fit: cover;
  min-height: 100%;
  z-index: -1;
  // transform: translate(-50%, -50%);
}
.headerLeft {
  /* background-color: aqua; */
  /* line-height: 50px; */
  color: white;
  width: px2vw(300);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: px2vw(30);
  font-size: px2vw(14);
  // font-family:;
}
.headerright {
  /* line-height: 50px; */
  color: white;
  width: px2vw(320);
  text-align: center;
  height: px2vw(30);
  /* background-color: aqua; */
  display: flex;
}
.timeBox {
  width: px2vw(180);
  height: px2vw(30);
  /* background-color: red; */
  /* padding: ; */
  text-align: right;
  // padding: px2vw(2) px2vw(20);
  display: flex;
  align-items: center;
}
.userInfoBox {
  width: px2vw(150);
  height: px2vw(30);
  /* background-color: red; */
  padding: px2vw(8);
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: end;
  margin-right: px2vw(20);
}
.atuoBox {
  width: px2vw(150);
  height: px2vw(50);
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: px2vw(14);
}
.atuoBtn {
  margin-left: px2vw(10);
}
.userInfoBoxItem {
  width: px2vw(120);
  // width: px2vw(95);
  height: px2vw(30);
  /* background-color: rgb(0, 255, 170); */
  background-image: url("./assets/Group_48097191.png");
  text-align: right;
  line-height: px2vw(30);
  font-size: px2vw(14);
  background-size: cover;
  text-align: right;
}
.tabbarImgBox {
  width: px2vw(98);
  height: px2vw(98);
  // background-color: red;
  text-align: center;
  position: relative;
}
@keyframes mymove {
  0% {
    top: 0px;
  }

  100% {
    top: -9px;
  }
}
.routerImg {
  height: px2vw(98);
  width: px2vw(98);
  position: relative;
  top: 0px;
}
.moeIcon {
  animation: mymove 2s infinite alternate linear;
}
.routerImg2 {
  height: px2vw(98);
  width: px2vw(98);
  position: absolute;
  bottom: px2vw(-5);
  z-index: -1;
  left: px2vw(0);
  // background-color: red;
}
.notChooseImg {
  opacity: 0.7;
}
.headerBotton {
  height: px2vw(40);
  width: px2vw(535);
  position: absolute;
  top: px2vw(84);
  z-index: 999;
  text-align: center;
  /* width: 100%; */
  left: px2vw(693);
  background-image: url("./assets/Group_48097195.png");
  background-size: cover;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: rgba(163, 227, 241, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(14);
}
.myareaNameBox {
  // background-image: url("../assets/Group_1321314690_1.png");
  // -webkit-text-stroke: 0.1px black;
  width: px2vw(50);
  height: px2vw(50);
  background-size: 100% 100%;
  line-height: px2vw(25);
  color: white;
  position: relative;
  z-index: 999;
  font-weight: 700;
}
.myview {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
}
.tabbarBox {
  width: px2vw(718);
  height: px2vw(98);
  position: absolute;
  bottom: px2vw(50);
  // background-color: red;
  /* background-color: aqua; */
  z-index: 999;
  left: px2vw(601);
  // background-image: url("./assets/baner.png");
  background-size: cover;
  display: flex;
  justify-content: center;
  /* align-items: flex-end; */
  align-items: flex-end;
}
.tabbarBoxList {
  width: 100%;
  /* height: 50px; */
  /* background-color: azure; */
  /* position: absolute;
  bottom: 5px; */
  display: flex;
  justify-content: space-between;
}
.iconimg {
  width: px2vw(82);
  height: px2vw(101);
}
.weatherImg {
  width: px2vw(40);
  height: px2vw(40);
}
.Showweathetitle {
  margin-bottom: px2vw(10);
  text-align: center;
  height: px2vw(100);
  color: white;
  line-height: px2vw(100);
  font-size: px2vw(16);
}
.movebottom {
  height: px2vw(30);
  width: px2vw(100);
  // background-color: aqua;
  position: absolute;
  top: px2vw(50);
  z-index: 999;
}
.showTabBtn {
  height: 30px;
  width: 100px;
  position: absolute;
  bottom: px2vw(10);
  z-index: 999;
  left: 50%;
  transform: translateX(-50px);
  background-color: #28534193;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
}
.weatherInfoBox {
  width: 50vw;
  height: px2vw(300);
  // background-color: red;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  position: absolute;
  top: px2vw(300);
  left: 25vw;
  z-index: 9999;
  border: 1px solid #0ab4e1;
}
.weatherTitleBox {
  width: 100%;
  height: px2vw(48);
  background: linear-gradient(
    89.93deg,
    rgba(35, 105, 138, 0) 0.06%,
    rgba(43, 133, 175, 0.93) 10.86%,
    rgba(35, 105, 138, 1) 72.9%,
    rgba(35, 105, 138, 0) 98.55%
  );
  text-align: center;
  color: rgba(227, 236, 255, 1);
  line-height: px2vw(48);
  font-size: px2vw(18);
}
.closeBoxImg {
  position: absolute;
  right: 0;
  top: 0;
  width: px2vw(30);
  height: px2vw(30);
}
.mybottomGlassBox {
  height: px2vw(34);
  width: 100vw;
  position: absolute;
  z-index: 999;
  bottom: 0;
  // background-color: ;
  backdrop-filter: blur(5.5px);
  background: hsla(0, 0%, 100%, 0.15);
  display: flex;
  justify-content: space-between;
  padding: 0 px2vw(30);
}
.mybottomGlassBoxItemLeft {
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
  // background-color: red;
}
.mybottomGlassBoxItemLeft .switchBox {
  width: px2vw(100);
  height: 100%;
  // background-color: red;
  display: flex;
  font-size: px2vw(12);
  align-items: center;
  color: white;
  justify-content: center;
}
.mybottomGlassBoxItemright {
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
  // background-color: red;
}
.leaflet-popup-content-wrapper {
  border-radius: 4px;
  border-width: 2px;
  border-style: solid;
  border-image-source: linear-gradient(
    180deg,
    rgba(64, 255, 255, 0.62) 0%,
    rgba(64, 255, 255, 0) 43.88%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: rgba(2, 13, 17, 0.4) !important;
  box-shadow: 0px 0px 30px rgba(58, 211, 255, 0.3) inset,
    0px 0px 8px rgba(92, 184, 255, 0.24);
  backdrop-filter: blur(10px);
  color: rgb(186, 253, 255) !important;
  padding: 5px !important;
}
.leaflet-popup-content {
  margin: 0 !important;
}
.mybottomGlassBoxItemright .switchBox {
  width: px2vw(100);
  height: 100%;
  // background-color: red;
  display: flex;
  font-size: px2vw(12);
  align-items: center;
  color: white;
  justify-content: center;
}
.el-radio__label {
  font-size: px2vw(14) !important;
  color: white !important;
}
.myAiBox {
  height: px2vw(50);
  width: px2vw(50);
  // background-color: red;
  position: absolute;
  bottom: px2vw(40);
  right: px2vw(40);
  z-index: 9999;
}
.aiBoxPop {
  height: px2vw(600);
  width: px2vw(500);
  position: absolute;
  z-index: 9999;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  top: px2vw(100);
  right: px2vw(100);
  overflow: hidden;
}
.aiBoxPopTitel {
  height: px2vw(70);
  width: 100%;
  background-color: #2386a5;
  display: flex;
}
.aiBoxPopTitel .left {
  width: 80%;
  height: 100%;
  color: white;
  padding: 0 px2vw(20);
  line-height: px2vw(60);
  font-size: px2vw(20);
}
.aiCloseIcon {
  position: absolute;
  right: px2vw(5);
  top: px2vw(5);
}
.aiBoxPopMainBox {
  height: px2vw(350);
  width: px2vw(500);
  // background-color: #b0b6bb;
  overflow: auto;
  border-bottom: 1px solid #585858;
}
.AilistItem {
  height: auto;
  width: 100%;
  // background-color: #2d9b3c;
  // border: 1px solid red;
  padding: 0px px2vw(10);
  margin-bottom: px2vw(10);
}
.itemTimeBox {
  height: px2vw(20);
  font-size: px2vw(8);
  color: #585858;
}
.textbox {
  width: 50%;
  font-size: px2vw(14);
  color: black;
  // width: auto;
  margin-top: 0px;
  // background-color: red;
  border-radius: px2vw(5);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
}
.textbox2 {
  width: 50%;
  font-size: px2vw(14);
  color: white;
  // width: auto;
  background-color: #007aff;
  margin-top: 0px;
  text-align: right;
  // background-color: red;
  border-radius: px2vw(5);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
}
.mytextBox {
  // background-color: rgb(240, 240, 240);
  // border: 1px solid #58585825;
  padding: px2vw(5);
  font-family: DingTalk JinBuTi;
  // font-size: px2vw(18);
  // line-height: 120.000005%;
  letter-spacing: 10%;
  border-radius: px2vw(5);
  // background-color: #fff;
  line-height: px2vw(30);
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  // box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.2);
}
.mytextBox2 {
  // background-color: rgb(40, 121, 228);
  color: white;
  // border: 1px solid #58585825;
  padding: 5px;

  border-radius: 5px;
  // background-color: #fff;
  line-height: px2vw(30);
  // box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.2);
}
.myright {
  display: flex;
  justify-content: flex-end;
}
.myright2 {
  color: #007aff;

  font-weight: 600;
}
.myright3 {
  // text-align: right;
}
.aiBottomBox {
  height: px2vw(120);
  width: 100%;
  // background-color: #0ab4e1;
}
.mybotomeBix {
  position: absolute;
  bottom: px2vw(5);
  right: px2vw(5);
  width: px2vw(80);
  height: px2vw(30);
  background-color: #2386a5;
  text-align: center;
  color: white;
  line-height: px2vw(30);
  border-radius: px2vw(5);
}
.littttine {
  text-align: center;
}
.myinptAibox {
  z-index: 9999;
}
.footerDataText {
  width: px2vw(500);
  height: px2vw(30);
  line-height: 30px;
  text-align: center;
  // background-color: red;
  color: white;
}
.dashLine{
   stroke-dasharray: 10;
}
</style>
